import React, { useState } from "react";
import DiscountList from "./display-discount";
import CreateSpareDiscount from "./createsparediscount";
import CouponCreation from "./create-coupons";
import DisplayCoupons from "./Coupons";
import FreeProductForm from "./createfree-items";
import FreeItemsList from "./free-itemslist";
import CreateProductDiscount from "./create-productdis";
import AllDiscountCreation from "./alldiscounts-creation";


const Discounts = () => {
  const [activeTab, setActiveTab] = useState("Display-Discount");

  const tabs = [
    "Display-Discount",
    "Create-Spare-Dis",
    "create-Prod-Dis",
    "Coupons",
    "Display-Coupons",
    "Create-All-Dis",
   "create-free-prod",
    "Free-Items",
   

  ];

  return (
    <div style={styles.wrapper}>
      {/* ---------- TABS ---------- */}
      <div style={styles.tabs}>
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              ...styles.tabBtn,
              borderBottom:
                activeTab === tab ? "2px solid #005487" : "none",
              color: activeTab === tab ? "#005487" : "#333",
            }}
          >
            {tab}
          </button> 
        ))}
      </div>

      {/* ---------- TAB CONTENT ---------- */}
      {activeTab === "Display-Discount" && <DiscountList/>}
      {activeTab === "Create-Spare-Dis" && <CreateSpareDiscount/>}
      {activeTab === "create-Prod-Dis" && <CreateProductDiscount/>}
      {activeTab === "Coupons" && <CouponCreation/>}
      {activeTab === "Display-Coupons" && <DisplayCoupons/>}
      {activeTab === "Create-All-Dis" && <AllDiscountCreation/>}
      {/* {activeTab === "create-free-prod " && <FreeItemsList/>} */}
      {activeTab === "Free-Items" && <FreeItemsList/>}
      {activeTab === "create-free-prod" && <FreeProductForm/>}

    </div>
  );
};

export default Discounts;

/* ---------- STYLES ---------- */
const styles = {
  wrapper: {
    background: "#fff",
    padding: "15px",
    borderRadius: "6px",
  },

 tabs: {
  display: "flex",
  flexWrap: "wrap",      // 👈 allow wrapping
  gap: "10px",
  borderBottom: "1px solid #ddd",
  marginBottom: "15px",
},

  tabBtn: {
    background: "none",
    border: "none",
    padding: "10px 16px",
    cursor: "pointer",
    fontWeight: 500,
    whiteSpace: "nowrap",
  },
};
